import { takeLatest, all, call, put } from 'redux-saga/effects';

import apis from '../apis/chat';

import {
  types,
  startSessionSuccess,
  startSessionFailed,
} from '../redux/startSession';
import { updateSelectQuestion } from '../redux/selectQuestion';

function* startSessionFlow(action) {
  const { userID, QID } = action.payload;

  try {
    const response = yield call(apis.acceptTutor, userID, QID);

    const {
      data: { question },
    } = response;

    // notify start session success
    yield put(startSessionSuccess());

    // update selected question
    yield put(updateSelectQuestion(question));
  } catch (err) {
    yield put(startSessionFailed(err));
  }
}

export default function* () {
  yield all([takeLatest(types.START_SESSION, startSessionFlow)]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/startSession.js